import './_TokenTextContainer-2ab10996.css';

var classes = {"TokenTextContainer":"prc-Token-TokenTextContainer--rlDJ"};

export { classes as default };
